import { Component, createRef } from 'preact';
import PropTypes from 'prop-types';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

class Map extends Component {
    constructor(props) {
        super(props);
        this.map = null;
        this.myRef = createRef();
    }

    componentDidMount() {
        const { schools } = this.props;
        this.map = L.map(this.myRef.current, { scrollWheelZoom: false }).setView(
            [parseFloat(schools[0].lat), parseFloat(schools[0].lng)],
            7
        );

        L.tileLayer(
            'https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/{z}/{y}/{x}.png',
            {
                attribution: '&copy; <a href="https://www.kartverket.no/">Kartverket</a>',
                maxZoom: 19,
            }
        ).addTo(this.map);

        schools.forEach((item) => {
            L.marker([parseFloat(item.lat), parseFloat(item.lng)])
                .bindTooltip(item.schoolname)
                .addTo(this.map);
        });
    }

    componentWillUnmount() {
        this.map?.remove();
    }

    render() {
        return (
            <div class="map__container-wrapper">
                <div ref={this.myRef} class="map"></div>
            </div>
        );
    }
}

Map.propTypes = {
    schools: PropTypes.array,
};

export default Map;
